// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","4534":"440b9bda","6046":"568caf08"}[chunkId] + ".chunk.css";
};